import React, { useEffect, useState } from 'react'
import {
    BarcodeOutlined,
    CalculatorOutlined,
    CheckOutlined,
    CloudUploadOutlined,
    CoffeeOutlined,
    DoubleLeftOutlined,
    DoubleRightOutlined,
    FieldTimeOutlined,
    PrinterOutlined,
    RedoOutlined,
    UsergroupAddOutlined,
} from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

//steps: 1:others,2:date&object,3:confirm,4:completed,5:lottery,6:payment
export const Steps = ({
    reserve,
    period,
    setLoading,
    showMessage,

    isShowPrev,
    onPrevClick,
    isShowBack = false,
    onBackClick,

    isShowFood = false,
    onFoodClick,
    
    isShowNext,
    isEnableNext,
    onNextClick,
    isShowPrint = false,
    setPrintType,

    // CurrentStep,
    nextButtonText = 'مرحله بعد' }) => {
    const [colSpan, setColSpan] = useState(3);
    const [currentStep, setCurrentStep] = useState(1);
    // =================================================================
    useEffect(() => {
        var cnt = 5;
        if (period.isLottery)
            cnt++;

        if (period.getAdditionalFile)
            cnt++;

        if (period.havePayment)
            cnt++;

        if (cnt == 5 || cnt == 6)
            setColSpan(4);

        if (cnt == 7 || cnt == 8)
            setColSpan(3);

        switch (reserve?.reserveStatus) {
            case 'Register':
                setCurrentStep(1);
                return;
            case 'OtherEntered':
                setCurrentStep(2);
                return;
            case 'TimeSelected':
                setCurrentStep(3);
                return;
            case 'LotteryWaiting':
                setCurrentStep(4);
                return;
            case 'FailInLottery':
                setCurrentStep(6);
                return;
            case 'WonInLottery':
                setCurrentStep(7);
                return;
            case 'FileUploadWaiting':
                setCurrentStep(7);
                return;
            case 'PayWaiting':
                setCurrentStep(8);
                return;
            case 'Payed':
                setCurrentStep(8);
                return;
            case 'Completed':
                setCurrentStep(9);
                return;
            default:
                setCurrentStep(9);

        }

    });
    // =================================================================
    return (
        <>
            {/* {reserve?.reserveStatus} */}
            <Row className='sectionTitle step-container no-print'>
                <Col span={3} style={{ textAlign: 'left' }}>
                    {isShowPrev ? <Button
                        className='step-prev-btn btn-light'

                        onClick={() => { if (onPrevClick) onPrevClick() }}
                    >
                        <DoubleRightOutlined />
                        <span className='step-prev-btn-title'>
                            مرحله قبل
                        </span>
                    </Button> : <></>}

                    {isShowBack ? <Button
                        className='btn-light step-back-btn'

                        onClick={() => { if (onBackClick) onBackClick() }}
                    >
                        <DoubleRightOutlined />
                        <span className='step-back-btn-title'>
                            بازگشت
                        </span>
                    </Button> : <></>}

                    {isShowFood ? <Button
                        className='btn-info step-back-btn'
                        style={{ marginTop: '5px' }}
                        onClick={() => { if (onFoodClick) onFoodClick() }}
                    >

                        <span className='step-back-btn-title'>
                            غذا / پارکینگ
                        </span>
                        <CoffeeOutlined />
                    </Button> : <></>}


                </Col>

                <Col span={18}>
                    <Row justify={'center'}>
                        <Col span={colSpan}
                            className={currentStep == 1 ? 'steps current-step' : 'steps passed-step'} >
                            <div className='step-icon'>
                                <UsergroupAddOutlined />
                            </div>
                            <div className='step-title'>
                                لیست نفرات
                            </div>
                        </Col>

                        <Col span={colSpan} className={currentStep == 2 ? 'steps current-step' : currentStep > 2 ? 'steps passed-step' : 'steps future-step'} >
                            <div className='step-icon'>
                                <FieldTimeOutlined />
                            </div>
                            <div className='step-title'>
                                انتخاب تاریخ
                            </div>
                        </Col>

                        <Col span={colSpan} className={currentStep == 3 ? 'steps current-step' : currentStep > 3 ? 'steps passed-step' : 'steps future-step'}>
                            <div className='step-icon'>
                                <CalculatorOutlined />
                            </div>
                            <div className='step-title'>
                                مشاهده صورتحساب
                            </div>
                        </Col>

                        <Col span={colSpan} className={currentStep == 4 ? 'steps current-step' : currentStep > 4 ? 'steps passed-step' : 'steps future-step'}>
                            <div className='step-icon'>
                                <CheckOutlined />
                            </div>
                            <div className='step-title'>
                                ثبت نهایی
                            </div>
                        </Col>

                        {period.isLottery ?
                            <Col span={colSpan} className={currentStep == 5 ? 'steps current-step' : currentStep > 5 ? 'steps passed-step' : 'steps future-step'}>
                                <div className='step-icon'>
                                    <RedoOutlined />
                                </div>
                                <div className='step-title'>
                                    قرعه کشی
                                </div>
                            </Col> : <></>
                        }

                        {period.getAdditionalFile ?
                            <Col span={colSpan} className={currentStep == 7 ? 'steps current-step' : currentStep > 7 ? 'steps passed-step' : 'steps future-step'}>
                                <div className='step-icon'>
                                    <CloudUploadOutlined />
                                </div>
                                <div className='step-title'>
                                    بارگذاری مدارک
                                </div>
                            </Col> : <></>
                        }



                        {period.havePayment ?
                            <Col span={colSpan} className={currentStep == 8 ? 'steps current-step' : currentStep > 8 ? 'steps passed-step' : 'steps future-step'}>
                                <div className='step-icon'>
                                    <BarcodeOutlined />
                                </div>
                                <div className='step-title'>
                                    پرداخت
                                </div>
                            </Col> : <></>
                        }

                        <Col span={colSpan} className={currentStep == 9 ? 'steps current-step' : currentStep > 9 ? 'steps passed-step' : 'steps future-step'}>
                            <div className='step-icon'>
                                <CheckOutlined />
                            </div>
                            <div className='step-title'>
                                قطعی شده
                            </div>
                        </Col>
                    </Row>
                </Col>


                <Col span={3} >
                    {isShowNext ? <Button
                        className={isEnableNext ? 'step-next-btn btn-primary' : 'step-next-btn btn-light'}

                        disabled={!isEnableNext}
                        onClick={() => { if (onNextClick) onNextClick() }}
                    >
                        <span className='step-next-btn-title'>
                            {nextButtonText}
                        </span>
                        <DoubleLeftOutlined />
                    </Button> : <></>}

                    {isShowPrint ?
                        <>
                            <Button
                                className={'btn-primary step-print-btn'}

                                onClick={() => { setPrintType("factor"); setTimeout(() => window.print(), 500); }}
                            >
                                <span className='step-print-btn-title'>
                                    چاپ فاکتور
                                </span>
                                <PrinterOutlined />
                            </Button>

                            <Button
                                className={'btn-info step-print-btn'}
                                style={{ marginTop: '5px' }}
                                onClick={() => { setPrintType("reception"); setTimeout(() => window.print(), 500); }}
                            >
                                <span className='step-print-btn-title'>
                                    چاپ فرم پذیرش
                                </span>
                                <PrinterOutlined />
                            </Button>

                        </>
                        : <></>}
                </Col>
            </Row>
        </>
    )
}
